<template>
    <b-row class="min-vh-100">
        <b-col md="5" order="2" order-sm="2" order-md="1" class="auth-form-column">
            <div class="auth-form">
                <h1 v-html="$t('register.title')"></h1>
                <p v-html="$t('register.description')"></p>
                <b-form novalidate class="needs-validation" autocomplete="off">
                    <b-form-group :label="$t('register.input.email_label')" label-for="email">
                        <b-form-input
                                id="email"
                                v-model="email"
                                name="email"
                                type="email"
                                required
                                v-validate="'max:255|email'"
                                :state="validateState('email')"
                                aria-describedby="feedback-error"
                                :placeholder="$t('register.input.email_placeholder')"
                        ></b-form-input>
                        <b-form-invalid-feedback id="email" v-if="errors.email" :state="errors.email" :force-show="true" tag="span">{{ errors.email }}</b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group :label="$t('register.input.password_label')" label-for="password">
                        <b-form-input
                                id="password"
                                v-model="password"
                                type="password"
                                required
                                minlength="8"
                                aria-describedby="feedback-error"
                                :placeholder="$t('register.input.password_placeholder')"
                        ></b-form-input>
                        <password v-model="password" :strength-meter-only="true"/>
                        <b-form-invalid-feedback v-if="errors.password" :force-show="true" tag="span">{{ errors.password }}</b-form-invalid-feedback>
                    </b-form-group>
					<label class="checkbox-custom" :class="{'error' : terms_error}">
						<input type="checkbox" aria-describedby="feedback-error" v-model="terms" required>
						<span class="checker"></span>
						<span v-html="$t('register.term_label', {'link': '/' + $root.lang + '/terms-and-conditions'})"></span>
					</label>
					<b-form-group class="mt-2">
                        <b-button type="submit" variant="primary" @click.prevent="register" block :style="{'border-radius': 0, 'display': 'flex', 'justify-content': 'center', 'align-items': 'center'}">
                            {{ $t('register.button.register' )}} <span class="icon-arrow-btn ml-3"></span>
                        </b-button>
                    </b-form-group>
                </b-form>
                <p class="text-center" style="color: #A5A5A5;">- {{ $t('register.or') }} -</p>
                <social-login-buttons></social-login-buttons>

                <p class="font-weight-bold">{{ $t('register.login_label') }} <router-link :to="{name:'login'}">{{ $t('register.login_link') }}</router-link></p>
            </div>
        </b-col>
        <app-intro></app-intro>
    </b-row>
</template>

<script>
    import { errors } from '../../mixins/errors';
    import socialLoginButtons from './social-buttons';
    import { validation } from 'vue';
    import Password from 'vue-password-strength-meter';

    export default {
        name: 'login',
        mixins: [
            errors
        ],
        components: {
            'social-login-buttons': socialLoginButtons,
            Password
        },
        data() {
            return {
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
				terms: false,
				terms_error: false
            };
        },
        methods: {
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.veeErrors.has(ref);
                }

                return null;
            },
            register() {
                let data = {
                    email: this.email,
                    password: this.password,
                    terms: this.terms
                };
            	if(!this.terms) {
					this.terms_error = true;
					return;
				}
                this.$store.dispatch('auth/register', data).catch(e => {
                    this.handleResponseErrors(e);
                });
            }
        },
    }
</script>
